import React from 'react';
import { cx } from '../cx';

// D-09 §15.26 — Progress (.prog > i, value 0~100)
export interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
}

export function Progress({ value = 0, className = '', ...props }: ProgressProps) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className={cx('prog', className)} {...props}>
      <i style={{ width: `${pct}%` }} />
    </div>
  );
}
